import { Button } from "@/shared/components/ui/button";
import { Card } from "@/shared/components/ui/card";
import { Input } from "@/shared/components/ui/input";
import type { DateRange } from "@/shared/types";
import { format, parseISO } from "date-fns";
import type { CollectionsSizeSearchParams } from "../types/collection-types";
import { DateRangePicker } from "./DateRangePicker";

interface Props {
    value: CollectionsSizeSearchParams;
    onChange: (next: CollectionsSizeSearchParams) => void;
    onSearch: () => void;
    onReset: () => void;
}

export function CollectionsSizeSearchCard({ value, onChange, onSearch, onReset }: Props) {

    const dateRange: DateRange = {
        from: value.start_date ? parseISO(value.start_date) : undefined,
        to: value.end_date ? parseISO(value.end_date) : undefined,
    }

    return (
        <Card className="p-4">
            <div className="space-y-4">
                <div className="grid gap-4 md:grid-cols-3">
                    <div className="space-y-2">
                        <div className="text-sm font-medium">조회 기간 *</div>
                        <DateRangePicker
                            value={dateRange}
                            onChange={(next) =>
                                onChange({
                                    ...value,
                                    start_date: next.from ? format(next.from, "yyyy-MM-dd") : "",
                                    end_date: next.to ? format(next.to, "yyyy-MM-dd") : "",
                                })
                            }
                        />
                    </div>

                    <div className="space-y-2">
                        <div className="text-sm font-medium">DW Account ID</div>
                        <Input
                            value={value.dw_account_id ?? ""}
                            onChange={(e) => onChange({ ...value, dw_account_id: e.target.value })}
                            placeholder="선택사항"
                        />
                    </div>

                    <div className="space-y-2">
                        <div className="text-sm font-medium">채널</div>
                        <Input
                            value={value.channel ?? ""}
                            onChange={(e) => onChange({ ...value, channel: e.target.value })}
                            placeholder="선택사항"
                        />
                    </div>
                </div>

                <div className="grid gap-4 md:grid-cols-3">
                    <div className="space-y-2">
                        <div className="text-sm font-medium">리포트 타입</div>
                        <Input
                            value={value.report_type ?? ""}
                            onChange={(e) => onChange({ ...value, report_type: e.target.value })}
                            placeholder="선택사항"
                        />
                    </div>

                    <div className="flex items-end gap-2">
                        <Button onClick={onSearch}>검색</Button>
                        <Button variant="outline" onClick={onReset}>
                            초기화
                        </Button>
                    </div>
                </div>
            </div>
        </Card>
    );
}